module.exports = __webpack_public_path__ + "static/media/N01.c389ec33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/decors/N01.png
// module id = 236
// module chunks = 0